import React, { useEffect, useMemo, useState } from "react";
import { Tabs, Loading } from "@quark/design";
import CourseCard from "./card";
import Navigator from "../../component/navigator";
import { getCourseCategories } from "../../api";
import { CourseCategory } from "../../types";
import styles from "./index.module.scss";
import Footer from "../../component/footer";
import useDocumentTitle from "../../hooks/use-document-title";

const CourseList = () => {
  useDocumentTitle("课程列表");
  const [categories, setCategories] = useState<CourseCategory[]>([]);
  const [loading, setLoading] = useState(false);
  const tabs = useMemo(() => {
    return categories.map((c) => ({ label: c.cate, value: c.cate }));
  }, [categories]);
  const loaded = useMemo(() => {
    return !!categories.length;
  }, [categories]);

  const [curTab, setCurTab] = useState<string | number>("");

  useEffect(() => {
    setLoading(true);
    getCourseCategories()
      .then((data) => setCategories(data))
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className={styles.container}>
      <Navigator activeKey="course" />
      {loading && <Loading style={{ height: "80vh" }} />}
      {loaded && !loading && (
        <>
          <div className={styles.header}>
            <div className={styles["tab-container"]}>
              <Tabs
                dataSource={tabs}
                onChange={(tabValue) => setCurTab(tabValue)}
              />
            </div>
          </div>
          <div className={styles.content}>
            {categories.map((c) => (
              <React.Fragment key={c.cate}>
                {c.cate === curTab ? (
                  <div className={styles.cards}>
                    {c.courses.map((course, index) => (
                      <CourseCard
                        dataSource={course}
                        key={course.id}
                        style={{
                          animationDelay: index * 0.1 + "s",
                        }}
                      />
                    ))}
                  </div>
                ) : null}
              </React.Fragment>
            ))}
          </div>
        </>
      )}
      <Footer />
    </div>
  );
};

export default CourseList;
